
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[account]/[category]",
      function () {
        return require("private-next-pages/company/[account]/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[account]/[category]"])
      });
    }
  